import { Venue } from '@models/Venue'
import { VenuesCollection as VenuesCollectionModel } from '@models/VenuesCollection'
import { DndGrid } from '@pages/venues/detail/tabs/DndGrid'
import {
  fetchVenuesCollections,
  reorderVenuesCollection,
  updateVenuesCollection,
} from '@services/VenuesCollectionService'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getVenuesCollections,
  selectVenuesCollections,
} from '@store/VenuesCollectionReducer'
import { initialQuery, TableParams } from '@supplement-bacon/sb-table-filters'
import { useSBRM } from '@supplement-bacon/sbrm-react'
import { Card, Empty, Flex } from 'antd'
import { useEffect } from 'react'
import VenuesCollection from './VenuesCollection'

type Props = {
  venueId: number
}

const VenuesCollectionCardList = ({ venueId }: Props) => {
  const dispatch = useAppDispatch()
  const venueCollections = useAppSelector(selectVenuesCollections())
  const { isOpen } = useSBRM()

  const query: TableParams = {
    ...initialQuery,
    filters: { venues: [venueId] },
    columnKey: 'order',
    order: 'ascend',
    pagination: { ...initialQuery.pagination, pageSize: 1000 },
  }

  useEffect(() => {
    if (isOpen) return
    dispatch(getVenuesCollections(query))
  }, [venueId, isOpen])

  useEffect(() => {
    dispatch(getVenuesCollections(query))
  }, [venueId])

  return (
    <>
      <DndGrid<VenuesCollectionModel>
        items={venueCollections}
        styles={{
          idle: { cursor: 'move' },
          dragging: { opacity: 0.4 },
          over: { opacity: 0.4 },
        }}
        onItemsChange={(updatedNested) => {
          const nextOrderData = updatedNested.map((m, i) => ({
            id: m.id,
            order: i,
          }))
          reorderVenuesCollection(nextOrderData).then((_) =>
            fetchVenuesCollections(query)
          )
        }}
        renderItem={(item, style, ref) => (
          <Card
            ref={ref}
            style={style}
            title={<VenuesCollection.Header model={item} />}
          >
            <Flex gap={16} wrap>
              <VenuesCollection.Collection
                item={item}
                onUpdate={(items) => {
                  updateVenuesCollection({
                    ...item,
                    venues: items.map((item: Venue) => item.id),
                  }).then((_) => fetchVenuesCollections(query))
                }}
              />
            </Flex>
          </Card>
        )}
      />
      {venueCollections.length == 0 && (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={'No collection to display'}
        />
      )}
    </>
  )
}

type VenuesCollectionCardListType = {
  Card: typeof VenuesCollectionCardList
}

export { VenuesCollectionCardList, type VenuesCollectionCardListType }
